module.exports = {
  STEPS: {
    MIN_SUBJECTS_NO_REACHED: {
      message: "Select at least 2 subjects",
      variant: "warning"
    },
    MAX_SUBJECTS_REACHED: {
      message: "Select 7 subjects at most",
      variant: "warning"
    },
    MIN_CLASSES_NO_REACHED: {
      message: "Select at least 1 theory class",
      variant: "warning"
    },
    MAX_CLASSES_REACHED: {
      message: "Select 3 theory class by subject at most",
      variant: "warning"
    },
    MIN_COURSES_NO_REACHED: {
      message: "Select at least 1 practical class",
      variant: "warning"
    },
    MAX_COURSES_REACHED: {
      message: "Select 3 practical class at most",
      variant: "warning"
    }
  }
};